import { render, staticRenderFns } from "./compensation-list.vue?vue&type=template&id=5987f53a&scoped=true"
import script from "./compensation-list.vue?vue&type=script&lang=js"
export * from "./compensation-list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5987f53a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/johnson/WebStormProject/zm/zm-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5987f53a')) {
      api.createRecord('5987f53a', component.options)
    } else {
      api.reload('5987f53a', component.options)
    }
    module.hot.accept("./compensation-list.vue?vue&type=template&id=5987f53a&scoped=true", function () {
      api.rerender('5987f53a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/sale-management/compensation/compensation-list.vue"
export default component.exports